import type { HTMLAttributes } from 'react';
import { useCallback } from 'react';
import { theme } from '@timeedit/ui-components/antd';

type GetComponentProps<T> = (
  record: T,
  index?: number
) => HTMLAttributes<HTMLElement>;

const { useToken } = theme;

export const useRowProps = <T extends { id: string | number }>(
  onClick: (record: T) => void,
  selectedIds: (number | string)[]
) => {
  const { token } = useToken();
  return useCallback<GetComponentProps<T>>(
    (record: T) => ({
      onClick: () => onClick(record),
      style: {
        backgroundColor: selectedIds.includes(record.id)
          ? token.colorPrimaryBg
          : token.colorBgBase,
        color: selectedIds.includes(record.id)
          ? token.colorPrimary
          : token.colorText,
      },
    }),
    [selectedIds, onClick]
  );
};
